import Layout from '@/layouts/AppLayout'
import Empty from '@/layouts/Empty'
import Spa from '@/views/Spa'

export default {
  Layout: Layout,
  Empty: Empty,
  Spa: Spa,
  // (示例)
  Dashboard: () => import('@/views/Dashboard'),
  // nested
  Menu1: () => import('@/views/nested/Menu1'),
  'Menu1-1': () => import('@/views/nested/Menu1/Menu1-1'),
  'Menu1-2': () => import('@/views/nested/Menu1/Menu1-2'),
  'Menu1-3': () => import('@/views/nested/Menu1/Menu1-3'),
  'Menu1-2-1': () => import('@/views/nested/Menu1/Menu1-2/Menu1-2-1'),
  'Menu1-2-2': () => import('@/views/nested/Menu1/Menu1-2/Menu1-2-2'),
  Menu2: () => import('@/views/nested/Menu2'),
  /* ==createPageInsert== */
}
